module.exports = __webpack_public_path__ + "img/noa_burnette_preview.8a7419ee.png";